module.exports = __webpack_public_path__ + "img/6_strand_braid_splash.ff356a52.jpg";